// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[role=\"button\"],\r\na[role=\"menuitem\"]\r\n{\r\n\tcursor: pointer;\r\n}\r\ncode.inline\r\n{\r\n\tborder: 1px solid #CCCCCC;\r\n\tbackground-color: #e2e2e2;\r\n\tpadding: 0px 2px;\r\n}\r\n.v-context > li > a,\r\n.v-context ul > li > a\r\n{\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
